<template>
    <card class="card-plain team-container" v-loading="prefetching">
        <router-view>
        </router-view>
    </card>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import teamsStore from '@/store/modules/user/teams'

  export default {
    name: 'TeamContainer',

    beforeCreate () {
      this.$store.registerModule('user/teams'.split('/'), teamsStore)
    },

    beforeDestroy () {
      this.$store.unregisterModule('user/teams'.split('/'))
    },

    mounted () {
      if (this.$route.name === 'TeamContainer') {
        this.init()
      }
    },

    computed: {
      ...mapState('user/teams', {
        prefetched: state => state.prefetched,
        prefetching: state => state.prefetching,
        directTeam: state => state.directTeam,
        directQuestionnaire: state => state.directQuestionnaire
      })
    },

    methods: {
      ...mapActions('user/teams', { prefetch: 'prefetch' }),
      async init () {
        if (this.prefetched) {
          this._handlePrefetchedChange()
        } else {
          this.prefetch()
        }
      },
      _handlePrefetchedChange: function () {
        if (this.prefetched) {
          if (this.directTeam && this.directTeam._id) {
            this.$router.push({
              name: 'TeamView',
              params: { qid: this.directQuestionnaire._id, tid: this.directTeam._id }
            })
          } else if (this.directQuestionnaire && this.directQuestionnaire._id) {
            this.$router.push({ name: 'TeamSelection', params: { qid: this.directQuestionnaire._id } })
          } else {
            this.$router.push({ name: 'TeamQuestionnaires' })
          }
        }
      },
      languageFormatter: function (row, column, cellValue) {
        return this.$options.filters.languageString(cellValue)
      },
      dateFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatDate(cellValue)
      }
    },

    watch: {
      prefetched () {
        this._handlePrefetchedChange()
      },
      '$route' () {
        if (this.$route.name === 'TeamContainer') {
          this.init()
        }
      }
    }
  }
</script>
<style lang="scss">
    .team-container {
        .card-body {
          padding-top: 0 !important;
        }
    }
</style>
